import { groupByValue } from 'View/Component/SampleGrouping/Operations/GroupOperation'
import type { SavedViz } from '../Persistence/SavedViz'
import { SINK_REGISTRY } from '../Sinks/SinkRegistry'
import { BlastSource } from 'Model/Project/BlastSource'

// Load default workspace configuration with common visualizations
export const defaultWorkspace: SavedViz = {
  version: 'viz-v1',
  sources: {
    source1: {
      name: 'Default Source',
      config: {
        kind: 'pipeline/v1',
        pipeline: {
          filters: [],
          groupBys: [{ operationKey: groupByValue.key, metaDataField: 'sampleMetadata.customerSampleName', config: {} }],
          projections: [],
          sortBys: []
        }
      },
      sinks: {
        stackedBarChartNextId: {
          config: SINK_REGISTRY['stackedBar'].makeConfig('stackedBarChartNextId')
        },
        mapSinkId: {
          config: SINK_REGISTRY['map'].makeConfig('mapSinkId')
        },
        colorLegendSinkId: {
          config: SINK_REGISTRY['colorLegend'].makeConfig('colorLegendSinkId')
        },
        biodiversityRichnessSinkId: {
          config: SINK_REGISTRY['biodiversityRichness'].makeConfig('biodiversityRichnessSinkId')
        }
      },
      shared: {
        blastType: BlastSource.NCBI as const,
        taxonLevel: 'species' as const
      }
    }
  },
  grid: {
    layouts: {
      lg: [
        { i: 'stackedBarChartNextId', x: 0, y: 0, w: 7, h: 16 },
        { i: 'colorLegendSinkId', x: 7, y: 0, w: 2, h: 16 },
        { i: 'mapSinkId', x: 9, y: 0, w: 3, h: 16 },
        { i: 'biodiversityRichnessSinkId', x: 0, y: 16, w: 12, h: 16 }
      ],
      md: [
        { i: 'stackedBarChartNextId', x: 0, y: 0, w: 7, h: 16 },
        { i: 'colorLegendSinkId', x: 7, y: 0, w: 3, h: 16 },
        { i: 'mapSinkId', x: 0, y: 16, w: 10, h: 16 },
        { i: 'biodiversityRichnessSinkId', x: 0, y: 32, w: 10, h: 16 }
      ],
      sm: [
        { i: 'stackedBarChartNextId', x: 0, y: 0, w: 6, h: 16 },
        { i: 'colorLegendSinkId', x: 6, y: 0, w: 2, h: 16 },
        { i: 'mapSinkId', x: 0, y: 16, w: 8, h: 16 },
        { i: 'biodiversityRichnessSinkId', x: 0, y: 32, w: 8, h: 16 }
      ],
      xs: [
        { i: 'stackedBarChartNextId', x: 0, y: 0, w: 6, h: 16 },
        { i: 'colorLegendSinkId', x: 0, y: 16, w: 6, h: 10 },
        { i: 'mapSinkId', x: 0, y: 26, w: 6, h: 16 },
        { i: 'biodiversityRichnessSinkId', x: 0, y: 42, w: 6, h: 16 }
      ],
      xxs: [
        { i: 'stackedBarChartNextId', x: 0, y: 0, w: 4, h: 16 },
        { i: 'colorLegendSinkId', x: 0, y: 16, w: 4, h: 10 },
        { i: 'mapSinkId', x: 0, y: 26, w: 4, h: 16 },
        { i: 'biodiversityRichnessSinkId', x: 0, y: 42, w: 4, h: 16 }
      ]
    }
  }
} as const
